export const GET_SCHEDULES = Symbol('GET_SCHEDULES');
export const GET_SCHEDULES_REQUEST = Symbol('GET_SCHEDULES_REQUEST');
export const GET_SCHEDULES_SUCCESS = Symbol('GET_SCHEDULES_SUCCESS');
export const GET_SCHEDULES_ERROR = Symbol('GET_SCHEDULES_ERROR');

